import createIcon from '../../createIcon';

/**
 * @component @name EmojiPeople
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuODIwMyA2QzEyLjkyNDkgNiAxMy44MjAzIDUuMTA0NTcgMTMuODIwMyA0QzEzLjgyMDMgMi44OTU0MyAxMi45MjQ5IDIgMTEuODIwMyAyQzEwLjcxNTcgMiA5LjgyMDMxIDIuODk1NDMgOS44MjAzMSA0QzkuODIwMzEgNS4xMDQ1NyAxMC43MTU3IDYgMTEuODIwMyA2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1LjcxMDMgOC4xMUMxNS4zMjAzIDcuNzIgMTQuNjUwMyA3IDEzLjM1MDMgN0MxMy4xNDAzIDcgMTEuOTMwMyA3IDEwLjgxMDMgN0M4LjA2MDMxIDYuOTkgNS44MjAzMSA0Ljc1IDUuODIwMzEgMkgzLjgyMDMxQzMuODIwMzEgNS4xNiA1LjkzMDMxIDcuODQgOC44MjAzMSA4LjcxVjIySDEwLjgyMDNWMTZIMTIuODIwM1YyMkgxNC44MjAzVjEwLjA1TDE4Ljc3MDMgMTRMMjAuMTgwMyAxMi41OUwxNS43MTAzIDguMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EmojiPeople = createIcon('EmojiPeople', [
  [
    'path',
    {
      d: 'M11.8203 6C12.9249 6 13.8203 5.10457 13.8203 4C13.8203 2.89543 12.9249 2 11.8203 2C10.7157 2 9.82031 2.89543 9.82031 4C9.82031 5.10457 10.7157 6 11.8203 6Z',
      key: 'f28lyk',
    },
  ],
  [
    'path',
    {
      d: 'M15.7103 8.11C15.3203 7.72 14.6503 7 13.3503 7C13.1403 7 11.9303 7 10.8103 7C8.06031 6.99 5.82031 4.75 5.82031 2H3.82031C3.82031 5.16 5.93031 7.84 8.82031 8.71V22H10.8203V16H12.8203V22H14.8203V10.05L18.7703 14L20.1803 12.59L15.7103 8.11Z',
      key: 'sfmnfd',
    },
  ],
]);

export default EmojiPeople;
